import React from "react";
import Marquee from "react-fast-marquee";
import { Award, Shield, Headphones, CreditCard, Building2, Umbrella, Users, Star } from "lucide-react";
import { useLang } from "../../i18n/LanguageProvider";

const ICONS = [Award, Star, Headphones, CreditCard, Building2, Umbrella, Users, Shield];

export const TrustMarquee = () => {
  const { t } = useLang();
  const items = t.trust.items;

  return (
    <section
      data-testid="trust-section"
      className="relative py-10 md:py-12 bg-[#F5F1E8] border-y border-[#0B1416]/10"
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        {items.map((label, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <span key={i} className="marquee-item text-[#0B1416]">
              <Icon size={16} strokeWidth={1.4} />
              <span
                data-testid={`trust-item-${i}`}
                className="text-[13px] uppercase tracking-[0.28em] font-medium"
              >
                {label}
              </span>
              <span className="text-[#1BB6B9]" style={{ fontSize: 6 }}>
                ●
              </span>
            </span>
          );
        })}
      </Marquee>
    </section>
  );
};
